// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mobile-tips-span-wbIZT4{color:rgba(29,28,35,.8);text-align:center;font-size:.75rem;font-weight:400;line-height:1rem}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mobile-tips-span": `mobile-tips-span-wbIZT4`,
	"mobileTipsSpan": `mobile-tips-span-wbIZT4`
};
export default ___CSS_LOADER_EXPORT___;
